import { Settings2, ChevronDown, Clock } from 'lucide-react';
import { useState } from 'react';
import { AgentsPopup } from './AgentsPopup';

const MODEL_OPTIONS = [
  { id: 'gemini-flash', name: 'Gemini Flash', description: 'Fast responses for most queries' },
  { id: 'claude-sonnet', name: 'Claude Sonnet', description: 'Specialized in coding tasks' },
  { id: 'llama-70b', name: 'Llama 70B', description: 'Great for complex reasoning' }
];

const ChatHeader = ({ setIsSettingsOpen }) => {
  const [selectedModel, setSelectedModel] = useState('gemini-flash');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const allowModelChanges = localStorage.getItem('allowModelChanges') === 'true';
  const [isAgentsOpen, setIsAgentsOpen] = useState(false);

  const selectedModelName = MODEL_OPTIONS.find(m => m.id === selectedModel)?.name;

  return (
    <div className="sticky top-0 z-10 bg-white">
      <div className="flex justify-between items-center py-4 px-6">
        <div className="relative">
          {allowModelChanges && (
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center space-x-2 px-3 py-1.5 rounded-lg hover:bg-gray-100"
            >
              <span className="text-sm font-medium">{selectedModelName}</span>
              <ChevronDown className="h-4 w-4 text-gray-500" />
            </button>
          )}

          {isDropdownOpen && (
            <>
              <div 
                className="fixed inset-0" 
                onClick={() => setIsDropdownOpen(false)}
              />
              <div className="absolute left-0 mt-1 w-72 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
                {MODEL_OPTIONS.map(model => (
                  <button
                    key={model.id}
                    className={`w-full px-4 py-2 text-left hover:bg-gray-50 flex flex-col ${
                      selectedModel === model.id ? 'bg-gray-50' : ''
                    }`}
                    onClick={() => {
                      setSelectedModel(model.id);
                      setIsDropdownOpen(false);
                    }}
                  >
                    <span className="text-sm font-medium">{model.name}</span>
                    <span className="text-xs text-gray-500">{model.description}</span>
                  </button>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="relative flex items-center space-x-4">
          <button
            onClick={() => setIsAgentsOpen(true)}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
            title="Agents"
          >
            <Clock className="h-5 w-5" />
          </button>
          <button
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
            title="Settings"
            onClick={() => setIsSettingsOpen(true)}
          >
            <Settings2 className="h-5 w-5" />
          </button>
        </div>
      </div>

      <AgentsPopup
        isOpen={isAgentsOpen}
        onClose={() => setIsAgentsOpen(false)}
      />
    </div>
  );
};

export default ChatHeader; 